import {ready} from "./utils/ready";
import header from "./components/header";
import singleproduct from "./components/singleproduct";
import facetWp from "./components/facetwp";
import filter from "./components/filter";

ready(() => {
    header()
    filter()
    facetWp()
    singleproduct()
})
